<template>
  <div>
    <!-- Info Banner -->
    <div class="form-info-banner">
      <h3 class="form-info-banner-title">
        Os campos com * são de preenchimento obrigatório
      </h3>
      <p class="form-info-banner-text">
        Caso queira, você poderá salvar e continuar depois.
      </p>
    </div>

    <div class="space-y-8">
      <!-- Seção: Administrador -->
      <section class="form-section">
        <div class="form-section-header">
          <LabelDisclaimer
            :TamanhoFonteLabel="'H5'"
            :NomeLabel="'Administrador'"
            :Sessao="'Participantes'"
            :SubSessao="'Administrador'"
          />
        </div>
        <div class="form-section-content">
          <div class="form-grid-12">
            <div class="col-span-7 form-field">
              <label
                class="form-field-label form-field-label-required"
                for="razaoSocial"
                >Denominação social (sem abreviações)</label
              >
              <input
                class="field"
                type="text"
                @change="salvarAlteracoesLocalmenteParticipante"
                v-model="participante.Administrador"
                id="razaoSocial"
              />
              <p
                v-if="camposObrigatorios.erroParticipanteAdministrador"
                class="form-field-error"
              >
                Campo obrigatório.
              </p>
            </div>
            <div class="col-span-5 form-field">
              <label
                class="form-field-label form-field-label-required"
                for="cnpj"
                >CNPJ</label
              >
              <input
                class="field"
                type="text"
                @change="salvarAlteracoesLocalmenteParticipante"
                v-model="participante.AdministradorCnpj"
                id="cnpj"
                placeholder="AA.AAA.AAA/AAAA-00"
              />
              <p
                v-if="camposObrigatorios.erroParticipanteAdministradorCnpj"
                class="form-field-error"
              >
                Campo obrigatório.
              </p>
            </div>
          </div>

          <div
            v-for="(representante, index) in representantesAdministrador"
            :key="representante.Guid"
            class="mt-6 pt-6 border-t border-gray-200 dark:border-slate-700"
          >
            <div class="form-grid-12 mb-4">
              <div class="col-span-5 form-field">
                <InputNome
                  v-model="representante.Nome"
                  label="Representante legal"
                  :required="true"
                  :erro="
                    camposObrigatoriosRepresentante[index]?.erroNome &&
                    tentativaPostagem
                  "
                  @blur="salvarAlteracoesLocalmenteRepresentante"
                />
              </div>
              <div class="col-span-3 form-field">
                <label
                  class="form-field-label form-field-label-required"
                  for="cpfRepre"
                  >CPF</label
                >
                <input
                  class="field"
                  type="text"
                  @change="salvarAlteracoesLocalmenteRepresentante"
                  v-model="representante.CpfCnpj"
                  id="cpfRepre"
                  placeholder="000.000.000-00"
                />
                <p
                  v-if="
                    camposObrigatoriosRepresentante[index]?.erroCpfCnpj &&
                    tentativaPostagem
                  "
                  class="form-field-error"
                >
                  Campo obrigatório.
                </p>
              </div>
              <div class="col-span-4 form-field">
                <telefone-internacional
                  v-model="representante.Telefone"
                  label="Telefone"
                  :name="'TelefoneRepresentanteGestor_' + index"
                  :opcional="true"
                  @change="salvarAlteracoesLocalmenteRepresentante"
                  @validate="onValidateTelefoneRepresentanteGestor"
                />
              </div>
            </div>
            <div class="form-grid-12 mb-4">
              <div class="col-span-5 form-field">
                <label
                  class="form-field-label"
                  :for="'emailRepresentante_' + index"
                  >E-mail</label
                >
                <input
                  class="field"
                  :id="'emailRepresentante_' + index"
                  type="text"
                  @change="salvarAlteracoesLocalmenteRepresentante"
                  v-model="representante.Email"
                  @blur="validarEmailsRepresentanteAdmin(representante, index)"
                />
                <p
                  v-if="emailErros['emailRepresentanteAdmin_' + index]"
                  class="form-field-error"
                >
                  {{ emailErros["emailRepresentanteAdmin_" + index] }}
                </p>
              </div>
              <div class="col-span-3 form-field">
                <label class="form-field-label" for="cargo">Cargo</label>
                <input
                  class="field"
                  type="text"
                  @change="salvarAlteracoesLocalmenteRepresentante"
                  v-model="representante.Cargo"
                />
              </div>
              <div class="col-span-4 form-field">
                <label
                  class="form-field-label form-field-label-required"
                  for="assinatura"
                  >Assinatura</label
                >
                <select
                  id="assinante"
                  class="field"
                  @change="salvarAlteracoesLocalmenteRepresentante"
                  v-model="representante.Assinatura"
                >
                  <option value="">Selecione</option>
                  <option value="1">Não assina pela empresa</option>
                  <option value="2">Assina isoladamente</option>
                  <option value="0">Assina em conjunto</option>
                </select>
                <p
                  v-if="
                    camposObrigatoriosRepresentante[index]?.erroAssinatura &&
                    tentativaPostagem
                  "
                  class="form-field-error"
                >
                  Campo obrigatório.
                </p>
              </div>
              <div
                v-if="index > 0"
                class="col-span-1 form-field flex items-end"
              >
                <button
                  @click.stop.prevent="excluirRepresentante(index)"
                  class="btn-icon-danger"
                  title="Excluir representante"
                >
                  <i class="fa fa-trash"></i>
                </button>
              </div>
            </div>
          </div>

          <div class="mt-4">
            <button @click="addRepresentanteAdmin" class="btn-secondary">
              <i class="fa fa-plus mr-2"></i>
              Adicionar
            </button>
          </div>
        </div>
      </section>

      <!-- Seção: Gestor -->
      <section class="form-section">
        <div class="form-section-header">
          <LabelDisclaimer
            :TamanhoFonteLabel="'H5'"
            :NomeLabel="'Gestor'"
            :Sessao="'Participantes'"
            :SubSessao="'Gestor'"
          />
        </div>
        <div class="form-section-content">
          <div class="form-grid-12">
            <div class="col-span-7 form-field">
              <InputNome
                v-model="participante.Gestor"
                label="Denominação social ou Nome completo (sem abreviações)"
                :required="true"
                :erro="camposObrigatorios.erroParticipanteGestor"
                @blur="salvarAlteracoesLocalmenteParticipante"
              />
            </div>
            <div class="col-span-5 form-field">
              <label
                class="form-field-label form-field-label-required"
                for="gestorCnpj"
                >CNPJ/CPF</label
              >
              <input
                class="field"
                type="text"
                @change="salvarAlteracoesLocalmenteParticipante"
                v-model="participante.GestorCnpj"
                id="gestorCnpj"
                placeholder="AA.AAA.AAA/AAAA-00"
              />
              <p
                v-if="camposObrigatorios.erroParticipanteGestorCnpj"
                class="form-field-error"
              >
                Campo obrigatório.
              </p>
            </div>
          </div>

          <div
            v-for="(representante, index) in representantesGestor"
            :key="representante.Guid"
            class="mt-6 pt-6 border-t border-gray-200 dark:border-slate-700"
          >
            <div class="form-grid-12 mb-4">
              <div class="col-span-5 form-field">
                <InputNome
                  v-model="representante.Nome"
                  label="Representante legal"
                  :required="true"
                  :erro="
                    camposObrigatoriosRepresentante[index]?.erroNome &&
                    tentativaPostagem
                  "
                  @blur="salvarAlteracoesLocalmenteParticipante"
                />
              </div>
              <div class="col-span-3 form-field">
                <label
                  class="form-field-label form-field-label-required"
                  for="cpfGestor"
                  >CPF</label
                >
                <input
                  class="field"
                  type="text"
                  @change="salvarAlteracoesLocalmenteRepresentante"
                  v-model="representante.CpfCnpj"
                  id="cpfGestor"
                  placeholder="000.000.000-00"
                />
                <p
                  v-if="
                    camposObrigatoriosRepresentante[index]?.erroCpfCnpj &&
                    tentativaPostagem
                  "
                  class="form-field-error"
                >
                  Campo obrigatório.
                </p>
              </div>
              <div class="col-span-4 form-field">
                <telefone-internacional
                  v-model="representante.Telefone"
                  label="Telefone"
                  :name="'TelefoneRepresentanteGestor_' + index"
                  :opcional="true"
                  @change="salvarAlteracoesLocalmenteRepresentante"
                  @validate="onValidateTelefoneRepresentanteGestor"
                />
              </div>
            </div>
            <div class="form-grid-12 mb-4">
              <div class="col-span-5 form-field">
                <label
                  class="form-field-label"
                  :for="'emailRepresentanteGestor_' + index"
                  >E-mail</label
                >
                <input
                  class="field"
                  type="text"
                  :id="'emailRepresentanteGestor_' + index"
                  @change="salvarAlteracoesLocalmenteRepresentante"
                  v-model="representante.Email"
                  @blur="validarEmailsRepresentanteGestor(representante, index)"
                />
                <p
                  v-if="emailErros['emailRepresentanteGestor_' + index]"
                  class="form-field-error"
                >
                  {{ emailErros["emailRepresentanteGestor_" + index] }}
                </p>
              </div>
              <div class="col-span-3 form-field">
                <label class="form-field-label" for="cargoGestor">Cargo</label>
                <input
                  class="field"
                  type="text"
                  @change="salvarAlteracoesLocalmenteRepresentante"
                  v-model="representante.Cargo"
                />
              </div>
              <div class="col-span-4 form-field">
                <label
                  class="form-field-label form-field-label-required"
                  for="assinaturaGestor"
                  >Assinatura</label
                >
                <select
                  id="assinaturaGestor"
                  class="field"
                  @change="salvarAlteracoesLocalmenteRepresentante"
                  v-model="representante.Assinatura"
                >
                  <option value="">Selecione</option>
                  <option value="1">Não assina pela empresa</option>
                  <option value="2">Assina isoladamente</option>
                  <option value="0">Assina em conjunto</option>
                </select>
                <p
                  v-if="
                    camposObrigatoriosRepresentante[index]?.erroAssinatura &&
                    tentativaPostagem
                  "
                  class="form-field-error"
                >
                  Campo obrigatório.
                </p>
              </div>
              <div
                v-if="index > 0"
                class="col-span-1 form-field flex items-end"
              >
                <button
                  @click.stop.prevent="excluirRepresentante(index)"
                  class="btn-icon-danger"
                  title="Excluir representante"
                >
                  <i class="fa fa-trash"></i>
                </button>
              </div>
            </div>
          </div>

          <div class="mt-4">
            <button @click="addRepresentanteGestor" class="btn-secondary">
              <i class="fa fa-plus mr-2"></i>
              Adicionar
            </button>
          </div>
        </div>
      </section>

      <!-- Seção: Emissor de Ordem -->
      <section class="form-section">
        <div class="form-section-header">
          <LabelDisclaimer
            :TamanhoFonteLabel="'H5'"
            :NomeLabel="'Emissor de Ordem'"
            :Sessao="'Participantes'"
            :SubSessao="'Emissor de Ordem'"
          />
        </div>
        <div class="form-section-content">
          <div
            v-for="(emissorOrdem, index) in emissoresDeOrdens"
            :key="emissorOrdem.Guid"
            :class="{
              'mt-6 pt-6 border-t border-gray-200 dark:border-slate-700':
                index > 0,
            }"
          >
            <div class="form-grid-12 mb-4">
              <div class="col-span-7 form-field">
                <InputNome
                  v-model="emissorOrdem.Nome"
                  label="Representante legal"
                  :required="true"
                  :erro="
                    camposObrigatoriosEmissor[index]?.erroNome &&
                    tentativaPostagem
                  "
                  @blur="salvarAlteracoesLocalmenteEmissorOrdem"
                />
              </div>
              <div class="col-span-5 form-field">
                <label
                  class="form-field-label form-field-label-required"
                  for="emissorCnpj"
                  >CNPJ/CPF</label
                >
                <input
                  class="field"
                  type="text"
                  @change="salvarAlteracoesLocalmenteEmissorOrdem"
                  v-model="emissorOrdem.CpfCnpj"
                  id="emissorCnpj"
                  placeholder="AA.AAA.AAA/AAAA-00"
                />
                <p
                  v-if="
                    camposObrigatoriosEmissor[index]?.erroCpfCnpj &&
                    tentativaPostagem
                  "
                  class="form-field-error"
                >
                  Campo obrigatório.
                </p>
              </div>
            </div>
            <div class="form-grid-12 mb-4">
              <div class="col-span-4 form-field">
                <label
                  class="form-field-label form-field-label-required"
                  :for="'emailEmissorOrdem_' + index"
                  >E-mail</label
                >
                <input
                  class="field"
                  type="text"
                  :id="'emailEmissorOrdem_' + index"
                  @change="salvarAlteracoesLocalmenteEmissorOrdem"
                  v-model="emissorOrdem.Email"
                  @blur="validarEmailsEmissorOrdem(emissorOrdem, index)"
                />
                <p
                  v-if="emailErros['emailEmissorOrdem_' + index]"
                  class="form-field-error"
                >
                  {{ emailErros["emailEmissorOrdem_" + index] }}
                </p>
              </div>
              <div class="col-span-3 form-field">
                <telefone-internacional
                  v-model="emissorOrdem.Telefone"
                  label="Telefone"
                  :name="'Telefone_' + index"
                  @validate="onValidateTelefone"
                  @change="salvarAlteracoesLocalmenteEmissorOrdem"
                />
                <p
                  v-if="
                    camposObrigatoriosEmissor[index]?.erroTelefone &&
                    !emissorOrdem.Telefone
                  "
                  class="form-field-error"
                >
                  Telefone obrigatório ou inválido
                </p>
              </div>

              <div class="col-span-2 form-field">
                <label class="form-field-label">Considerado US Person?</label>
                <div class="form-radio-group">
                  <label class="form-radio-item">
                    <input
                      type="radio"
                      :id="'UsPerson_Nao' + index"
                      value="false"
                      :name="'UsPerson_' + index"
                      class="form-radio-input"
                      v-model="emissorOrdem.UsPerson"
                      @change="salvarAlteracoesLocalmenteEmissorOrdem"
                    />
                    <span class="form-radio-label">Não</span>
                  </label>
                  <label class="form-radio-item">
                    <input
                      type="radio"
                      :id="'UsPerson_Sim' + index"
                      value="true"
                      :name="'UsPerson_' + index"
                      class="form-radio-input"
                      v-model="emissorOrdem.UsPerson"
                      @change="salvarAlteracoesLocalmenteEmissorOrdem"
                    />
                    <span class="form-radio-label">Sim</span>
                  </label>
                </div>
              </div>
              <div class="col-span-2 form-field">
                <label class="form-field-label">Politicamente Exposto?</label>
                <div class="form-radio-group">
                  <label class="form-radio-item">
                    <input
                      type="radio"
                      :id="'PoliticamenteExposta_Nao' + index"
                      value="false"
                      :name="'PoliticamenteExposta_' + index"
                      class="form-radio-input"
                      v-model="emissorOrdem.PoliticamenteExposta"
                      @change="salvarAlteracoesLocalmenteEmissorOrdem"
                    />
                    <span class="form-radio-label">Não</span>
                  </label>
                  <label class="form-radio-item">
                    <input
                      type="radio"
                      :id="'PoliticamenteExposta_Sim' + index"
                      value="true"
                      :name="'PoliticamenteExposta_' + index"
                      class="form-radio-input"
                      v-model="emissorOrdem.PoliticamenteExposta"
                      @change="salvarAlteracoesLocalmenteEmissorOrdem"
                    />
                    <span class="form-radio-label">Sim</span>
                  </label>
                </div>
              </div>
              <div
                v-if="index > 0"
                class="col-span-1 form-field flex items-end"
              >
                <button
                  @click.stop.prevent="excluirEmissorOrdem(index)"
                  class="btn-icon-danger"
                  title="Excluir emissor de ordem"
                >
                  <i class="fa fa-trash"></i>
                </button>
              </div>
            </div>
          </div>

          <div class="mt-4">
            <button @click="addEmisorOrdem" class="btn-secondary">
              <i class="fa fa-plus mr-2"></i>
              Adicionar
            </button>
          </div>
        </div>
      </section>

      <!-- Seção: Custodiante -->
      <section class="form-section">
        <div class="form-section-header">
          <LabelDisclaimer
            :TamanhoFonteLabel="'H5'"
            :NomeLabel="'Custodiante'"
            :Sessao="'Participantes'"
            :SubSessao="'Custodiante'"
          />
        </div>
        <div class="form-section-content">
          <div class="form-grid-12">
            <div class="col-span-7 form-field">
              <InputNome
                v-model="participante.Custodiante"
                label="Denominação social ou Nome completo (sem abreviações)"
                :required="true"
                :erro="camposObrigatorios.erroParticipanteCustodiante"
                @blur="salvarAlteracoesLocalmenteParticipante"
              />
            </div>
            <div class="col-span-5 form-field">
              <label
                class="form-field-label form-field-label-required"
                for="custodianteCnpj"
                >CNPJ</label
              >
              <input
                class="field"
                type="text"
                @change="salvarAlteracoesLocalmenteParticipante"
                v-model="participante.CustodianteCnpj"
                id="custodianteCnpj"
                placeholder="AA.AAA.AAA/AAAA-00"
              />
              <p
                v-if="camposObrigatorios.erroParticipanteCustodianteCnpj"
                class="form-field-error"
              >
                Campo obrigatório.
              </p>
            </div>
          </div>
          <div class="form-grid-12">
            <div class="col-span-4 form-field">
              <label class="form-field-label" for="cblc">Código CBLC</label>
              <input
                class="field"
                type="text"
                @change="salvarAlteracoesLocalmenteParticipante"
                v-model="participante.CustodianteCBLC"
                id="cblc"
              />
            </div>
          </div>
        </div>
      </section>

      <!-- Seção: Outros Participantes -->
      <section class="form-section">
        <div class="form-section-header flex justify-between items-center">
          <div v-if="!listaRepresentantes?.length > 0">
            <LabelDisclaimer
              :TamanhoFonteLabel="'H3'"
              :NomeLabel="'Outros participantes'"
              :Sessao="'Participantes'"
              :SubSessao="'Outros participantes'"
            />
            <p class="text-sm text-gray-600 dark:text-gray-400 mt-2">
              Clique em adicionar e selecione entre as opções: Diretor ou
              Administrador.
            </p>
          </div>
          <div v-if="listaRepresentantes?.length > 0" class="flex-1">
            <h3 class="text-lg font-semibold text-gray-900 dark:text-gray-100">
              Outros participantes
            </h3>
            <p class="text-sm text-gray-600 dark:text-gray-400 mt-1">
              Clique em adicionar e selecione entre as opções Diretor ou
              Administrador.
            </p>
          </div>
          <div v-if="listaRepresentantes?.length > 0">
            <button class="btn-secondary" @click="addParticipante()">
              <i class="fa fa-plus mr-2"></i>
              Adicionar
            </button>
          </div>
        </div>
        <div class="form-section-content">
          <!-- Estado vazio -->
          <div
            v-if="!listaRepresentantes?.length > 0"
            class="text-center py-12"
          >
            <img
              src="@/assets/addRepresentante.png"
              class="mx-auto mb-4 w-12 h-12 opacity-50"
            />
            <h3
              class="text-base font-semibold text-gray-900 dark:text-gray-100 mb-2"
            >
              Nenhum participante adicionado
            </h3>
            <p class="text-sm text-gray-600 dark:text-gray-400 mb-4">
              Clique em adicionar e selecione entre as opções Diretor ou
              Administrador.
            </p>
            <button class="btn-secondary" @click="addParticipante()">
              <i class="fa fa-plus mr-2"></i>
              Adicionar
            </button>
          </div>

          <!-- Tabela -->
          <div v-if="listaRepresentantes?.length > 0" class="overflow-x-auto">
            <table
              class="min-w-full divide-y divide-gray-200 dark:divide-slate-700"
            >
              <thead class="bg-gray-50 dark:bg-slate-800">
                <tr>
                  <th
                    class="px-4 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider"
                  >
                    Nome
                  </th>
                  <th
                    class="px-4 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider"
                  >
                    Tipo
                  </th>
                  <th
                    class="px-4 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider"
                  >
                    CPF/CNPJ
                  </th>
                  <th
                    class="px-4 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider"
                  >
                    Telefone
                  </th>
                  <th
                    class="px-4 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider"
                  >
                    E-mail
                  </th>
                  <th
                    class="px-4 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider"
                  >
                    Assinatura
                  </th>
                  <th
                    class="px-4 py-3 text-right text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider"
                  >
                    Ações
                  </th>
                </tr>
              </thead>
              <tbody
                class="bg-white dark:bg-slate-900 divide-y divide-gray-200 dark:divide-slate-700"
              >
                <tr
                  v-for="(representanteObj, index) in listaRepresentantes"
                  :key="index"
                  class="hover:bg-gray-50 dark:hover:bg-slate-800"
                >
                  <td
                    class="px-4 py-3 text-sm text-gray-900 dark:text-gray-100"
                  >
                    {{ representanteObj.Nome }}
                  </td>
                  <td
                    class="px-4 py-3 text-sm text-gray-600 dark:text-gray-400"
                  >
                    {{ representanteObj.Tipo }}
                  </td>
                  <td
                    class="px-4 py-3 text-sm text-gray-600 dark:text-gray-400"
                  >
                    {{ formatCpfCnpj(representanteObj.CpfCnpj) }}
                  </td>
                  <td
                    class="px-4 py-3 text-sm text-gray-600 dark:text-gray-400"
                  >
                    {{ representanteObj.Telefone }}
                  </td>
                  <td
                    class="px-4 py-3 text-sm text-gray-600 dark:text-gray-400"
                  >
                    {{ representanteObj.Email }}
                  </td>
                  <td
                    class="px-4 py-3 text-sm text-gray-600 dark:text-gray-400"
                  >
                    {{ representanteObj.AssinaturaFormatada }}
                  </td>
                  <td class="px-4 py-3 text-sm text-right">
                    <div class="flex gap-2 justify-end">
                      <button
                        @click.stop.prevent="editarParticipante(index)"
                        class="text-blue-600 hover:text-blue-800 dark:text-blue-400 dark:hover:text-blue-300"
                        title="Editar"
                      >
                        <i class="fa fa-edit"></i>
                      </button>
                      <button
                        @click.stop.prevent="excluirParticipante(index)"
                        class="text-red-600 hover:text-red-800 dark:text-red-400 dark:hover:text-red-300"
                        title="Excluir"
                      >
                        <i class="fa fa-trash"></i>
                      </button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </section>
    </div>
    <ModalAddParticipante />
    <ModalAlerta
      :mostrar="modalAlerta.mostrar"
      :tipo="modalAlerta.tipo"
      :titulo="modalAlerta.titulo"
      :mensagem="modalAlerta.mensagem"
      @fechar="modalAlerta.mostrar = false"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import emailValidatorMixin from "@/utils/emailValidatorMixin.js";
import api from "@/api/axios";
import formatCpfCnpj from "@/utils/formatCpfCnpj";
import ModalAddParticipante from "./ModalAddParticipante.vue";
import LabelDisclaimer from "@/components/LabelDisclaimer.vue";
import { makeSnapshot, hasChanges } from "@/utils/dirtyTracker";
import ModalAlerta from "../Utilitarios/ModalAlerta.vue";
import { confirmarReassinatura } from "@/utils/confirmarReassinatura";
import { verificarDocumentoAtivo } from "@/utils/verificarDocumentoAtivo";

export default {
  name: "CadastroOutros_Participantes",
  mixins: [formatCpfCnpj, emailValidatorMixin],
  props: ["informacoesParticipantes", "Edicao", "emissoresDeOrdensBD"],
  components: { ModalAddParticipante, LabelDisclaimer, ModalAlerta },
  computed: {
    ...mapGetters({
      user: "auth/user",
      listaRepresentantes: "GET_LISTA_PARTICIPANTES_FI",
      listaDeRepresentantes: "GET_FI_INFO_PARTICIPANTE_REPRESENTANTE",
    }),
    representantesAdministrador() {
      return this.representantes.filter(
        (r) => r.Tipo === "representanteAdministrador",
      );
    },
    representantesGestor() {
      return this.representantes.filter(
        (r) => r.Tipo === "gestor" || r.Tipo === "Gestor",
      );
    },
  },
  data() {
    return {
      modalAlerta: {
        mostrar: false,
        tipo: "warning",
        titulo: "",
        mensagem: "",
      },
      permitirAvancar: false,
      telefoneValido: [],
      telefoneRepresentanteGestorValido: [],
      emailErros: {},
      camposObrigatorios: {
        erroParticipanteAdministrador: false,
        erroParticipanteAdministradorCnpj: false,
        erroParticipanteGestor: false,
        erroParticipanteGestorCnpj: false,
        erroParticipanteCustodiante: false,
        erroParticipanteCustodianteCnpj: false,
      },
      //camposObrigatoriosRepresentante: [],
      camposObrigatoriosRepresentante: [
        {
          erroNome: false,
          erroCnpj: false,
          erroAssinatura: false,
        },
      ],
      //camposObrigatoriosGestor: [],
      camposObrigatoriosEmissor: [],
      participante: this.informacoesParticipantes,
      informacoesParticipantesRepresentantes: this.listaDeRepresentantes,
      representantes: [],
      emissoresDeOrdens: [],
      nomeRepresentante: {
        Guid: "",
        Nome: "",
        CpfCnpj: "",
        Tipo: "",
        Email: "",
        Cargo: "",
        Telefone: "",
      },
    };
  },
  mounted() {
    this.$store.commit("SET_MODAL_FI_ADD_PARTICIPANTE", false);
    this.$store.dispatch("FETCH_FI_INFO_PARTICIPANTE_REPRESENTANTE");
    this.informacoesParticipantesRepresentantes = this.listaDeRepresentantes;
    var possuiGestor = this.informacoesParticipantesRepresentantes.some(
      (representante) =>
        representante.Tipo === "gestor" || representante.Tipo == "Gestor",
    );
    var possuiAdministrador = this.informacoesParticipantesRepresentantes.some(
      (representante) => representante.Tipo === "representanteAdministrador",
    );
    var possuiEmissorOrdem = this.emissoresDeOrdensBD.length > 0 ? true : false;
    this.emissoresDeOrdens = this.emissoresDeOrdensBD;
    if (!possuiEmissorOrdem) {
      this.addEmisorOrdem();
    }
    if (possuiGestor && possuiAdministrador) {
      this.representantes = this.informacoesParticipantesRepresentantes;
    } else {
      if (!possuiGestor && !possuiAdministrador) {
        this.addRepresentanteGestor();
        this.addRepresentanteAdmin();
      }
      if (!possuiGestor) {
        this.representantes = this.informacoesParticipantesRepresentantes;
        this.addRepresentanteGestor();
      }
      if (!possuiAdministrador) {
        this.representantes = this.informacoesParticipantesRepresentantes;
        this.addRepresentanteAdmin();
      }
    }

    this.inicializarCamposObrigatoriosRepresentante();
    this.inicializarCamposObrigatoriosEmissor();

    this._repSnap = makeSnapshot(this.representantes);
  },
  watch: {
    listaDeRepresentantes() {
      this.informacoesParticipantesRepresentantes = this.listaDeRepresentantes;
      var possuiGestor = this.informacoesParticipantesRepresentantes.some(
        (representante) =>
          representante.Tipo === "gestor" || representante.Tipo == "Gestor",
      );
      var possuiAdministrador =
        this.informacoesParticipantesRepresentantes.some(
          (representante) =>
            representante.Tipo === "representanteAdministrador",
        );
      var possuiEmissorOrdem =
        this.emissoresDeOrdensBD.length > 0 ? true : false;
      this.emissoresDeOrdens = this.emissoresDeOrdensBD;
      if (!possuiEmissorOrdem) {
        this.addEmisorOrdem();
      }
      if (possuiGestor && possuiAdministrador) {
        this.representantes = this.informacoesParticipantesRepresentantes;
      } else {
        if (!possuiGestor && !possuiAdministrador) {
          this.addRepresentanteGestor();
          this.addRepresentanteAdmin();
        }
        if (!possuiGestor) {
          this.representantes = this.informacoesParticipantesRepresentantes;
          this.addRepresentanteGestor();
        }
        if (!possuiAdministrador) {
          this.representantes = this.informacoesParticipantesRepresentantes;
          this.addRepresentanteAdmin();
        }
      }
    },
    representantes: {
      handler(newRepresentante) {
        this.camposObrigatoriosRepresentante = newRepresentante.map(() => ({
          erroNome: false,
          erroCnpj: false,
          erroAssinatura: false,
        }));
      },
      immediate: true,
    },
    emissoresDeOrdens: {
      handler(newEmissoresDeOrdens) {
        this.camposObrigatoriosEmissor = newEmissoresDeOrdens.map(() => ({
          erroNome: false,
          erroCnpj: false,
          erroEmail: false,
          erroTelefone: false,
        }));
      },
      immediate: true,
    },
  },
  methods: {
    houveAlteracaoRepresentantesCriticos() {
      return hasChanges(this.representantes, this._repSnap);
    },
    onValidateTelefone({ name, valid }) {
      if (!this.telefoneValido) {
        this.telefoneValido = {};
      }
      if (valid != "undefined") {
        this.telefoneValido[name] = valid;
      }
    },
    onValidateTelefoneGestor({ name, valid }) {
      if (!this.telefoneSocioValido) {
        this.telefoneGestorValido = {};
      }
      if (valid != "undefined") {
        this.telefoneGestorValido[name] = valid;
      }
    },
    onValidateTelefoneRepresentanteGestor({ name, valid }) {
      if (!this.telefoneSocioValido) {
        this.telefoneRepresentanteGestorValido = {};
      }
      if (valid != "undefined") {
        this.telefoneRepresentanteGestorValido[name] = valid;
      }
    },
    validarEmailsRepresentanteAdmin(representante, index) {
      const fieldId = "emailRepresentanteAdmin_" + index;

      this.validarEmailGeneric(representante.Email, fieldId, {
        obrigatorio: true,
        mensagemObrigatorio: "Campo obrigatório.",
      });
    },
    validarEmailsRepresentanteGestor(representante, index) {
      const fieldId = "emailRepresentanteGestor_" + index;

      this.validarEmailGeneric(representante.Email, fieldId, {
        obrigatorio: false,
      });
    },
    validarEmailsEmissorOrdem(representante, index) {
      const fieldId = "emailEmissorOrdem_" + index;

      this.validarEmailGeneric(representante.Email, fieldId, {
        obrigatorio: true,
        mensagemObrigatorio: "Campo obrigatório.",
      });
    },
    addParticipante() {
      this.$store.commit("SET_MODAL_FI_EDITAR_PARTICIPANTE", null);
      this.$store.commit("SET_MODAL_FI_ADD_PARTICIPANTE", true);
    },
    editarParticipante(index) {
      this.$store.commit(
        "SET_MODAL_FI_EDITAR_PARTICIPANTE",
        this.listaRepresentantes[index],
      );
      this.$store.commit("SET_MODAL_FI_ADD_PARTICIPANTE", true);
    },
    async excluirEmissorOrdem(index) {
      if (this.emissoresDeOrdens[index].Guid == "") {
        this.emissoresDeOrdens.splice(index, 1);
        this.$store.commit(
          "SET_FI_SALVAR_INFO_EMISSOR_ORDEM",
          this.emissoresDeOrdens,
        );
        this.modalAlerta = {
          mostrar: true,
          tipo: "success",
          titulo: "Exclusão realizada com sucesso!",
          mensagem: "Dados informados foram excluídos com sucesso.",
        };
        return;
      }
      await api
        .get(
          `fundo/pessoaAutorizadaEmitirOrdem/excluir?guid=${this.emissoresDeOrdens[index].Guid}`,
        )
        .then((retorno) => {
          if (retorno.status == 200) {
            this.modalAlerta = {
              mostrar: true,
              tipo: "success",
              titulo: "Exclusão realizada com sucesso!",
              mensagem: "Dados informados foram excluídos com sucesso.",
            };
            this.$store.dispatch("FETCH_FI_INFO_EMISSOR_ORDEM");
          }
        })
        .catch((error) => {
          this.modalAlerta = {
            mostrar: true,
            tipo: "error",
            titulo: "Dados informados inválidos.",
            mensagem: `${error.response.data.data[0]}`,
          };
        });
    },
    async excluirParticipante(index) {
      await api
        .get(
          `fundo/emissorOrdem/excluir?guid=${this.listaRepresentantes[index].Guid}`,
        )
        .then((retorno) => {
          if (retorno.status == 200) {
            this.modalAlerta = {
              mostrar: true,
              tipo: "success",
              titulo: "Exclusão realizada com sucesso!",
              mensagem: "Dados informados foram excluídos com sucesso.",
            };
            this.$store.dispatch("FETCH_FI_INFO_PARTICIPANTE_CUSTODIANTE");
            this.validarFormulario();
          }
        })
        .catch((error) => {
          this.modalAlerta = {
            mostrar: true,
            tipo: "error",
            titulo: "Dados informados inválidos.",
            mensagem: `${error.response.data.data[0]}`,
          };
        });
    },
    async proximaEtapa() {
      if (await this.validarFormulario(true)) {
        this.$store.commit("SET_FI_SALVAR_INFO", true);
        this.$store.commit("SET_SALVAR_INFO_DES_NOTIFICACAO", true);
        this.$store.commit("SET_ETAPA_CADASTRO", 3);
      }
    },
    async validarFormulario(submeter) {
      this.permitirAvancar = true;
      var valorInvalido = false;
      this.tentativaPostagem = submeter;
      var nomeDoCampo = "";
      this.camposObrigatorios = {
        erroParticipanteAdministrador: false,
        erroParticipanteAdministradorCnpj: false,
        erroParticipanteGestor: false,
        erroParticipanteGestorCnpj: false,
        erroParticipanteCustodiante: false,
        erroParticipanteCustodianteCnpj: false,
      };
      let continuar = true;
      if (!this.participante.Administrador) {
        if (submeter && this.permitirAvancar) {
          this.camposObrigatorios.erroParticipanteAdministrador = true;
          nomeDoCampo = "Denominação social do Administrador";
        }
        this.permitirAvancar = false;
        continuar = false;
      }
      if (continuar && !this.participante.AdministradorCnpj) {
        if (submeter && this.permitirAvancar) {
          this.camposObrigatorios.erroParticipanteAdministradorCnpj = true;
          nomeDoCampo = "CNPJ do Administrador";
        }
        this.permitirAvancar = false;
        continuar = false;
      }
      if (continuar) {
        for (let index = 0; index < this.representantes.length; index++) {
          const obj = this.representantes[index];
          if (!obj.Nome) {
            this.camposObrigatoriosRepresentante[index].erroNome = true;
            this.permitirAvancar = false;
            if (submeter && nomeDoCampo === "") {
              nomeDoCampo =
                "Nome do " +
                (obj.Tipo == "representanteAdministrador"
                  ? "representante legal do Administrador"
                  : "representante legal do Gestor");
            }
            continuar = false;
            break;
          } else {
            this.camposObrigatoriosRepresentante[index].erroNome = false;
          }
          if (!obj.CpfCnpj) {
            this.camposObrigatoriosRepresentante[index].erroCnpj = true;
            this.permitirAvancar = false;
            if (submeter && nomeDoCampo === "") {
              nomeDoCampo =
                "CPF do " +
                (obj.Tipo == "representanteAdministrador"
                  ? "representante legal do Administrador"
                  : "representante legal do Gestor");
            }
            continuar = false;
            break;
          } else {
            this.camposObrigatoriosRepresentante[index].erroCnpj = false;
          }
          if (
            obj.Assinatura === null ||
            obj.Assinatura === undefined ||
            obj.Assinatura === ""
          ) {
            this.camposObrigatoriosRepresentante[index].erroAssinatura = true;
            this.permitirAvancar = false;
            if (submeter && nomeDoCampo === "") {
              nomeDoCampo =
                "Assinatura do " +
                (obj.Tipo == "representanteAdministrador"
                  ? "representante legal do Administrador"
                  : "representante legal do Gestor");
            }
            continuar = false;
            break;
          } else {
            this.camposObrigatoriosRepresentante[index].erroAssinatura = false;
          }

          const telefoneRepresentanteGestorValido =
            this.telefoneRepresentanteGestorValido[
              `TelefoneRepresentanteGestor_${index}`
            ];

          if (
            obj.Telefone.length > 4 &&
            (!obj.Telefone || telefoneRepresentanteGestorValido == false)
          ) {
            if (submeter && this.permitirAvancar) {
              this.camposObrigatoriosRepresentante[index].erroTelefone = true;
              nomeDoCampo =
                "Telefone do " +
                (obj.Tipo == "representanteAdministrador"
                  ? "representante legal do Administrador"
                  : "representante legal do Gestor");
            }
            if (telefoneRepresentanteGestorValido == false) {
              valorInvalido = true;
            }
            this.permitirAvancar = false;
            continuar = false;
            break;
          } else {
            this.camposObrigatoriosRepresentante[index].erroTelefone = false;
          }

          if (
            (this.temErrosEmailPorPrefixo("emailRepresentanteAdmin_") &&
              obj.Tipo == "representanteAdministrador") ||
            (this.temErrosEmailPorPrefixo("emailRepresentanteGestor") &&
              obj.Tipo != "representanteAdministrador")
          ) {
            this.permitirAvancar = false;
            if (submeter && nomeDoCampo === "") {
              nomeDoCampo =
                "e-mail do " +
                (obj.Tipo == "representanteAdministrador"
                  ? "representante legal do Administrador"
                  : "representante legal do Gestor");
            }
            continuar = false;
            break;
          }
        }
      }
      if (continuar && !this.participante.Gestor) {
        if (submeter && this.permitirAvancar) {
          this.camposObrigatorios.erroParticipanteGestor = true;
          nomeDoCampo = "Denominação social ou Nome completo do Gestor";
        }
        this.permitirAvancar = false;
        continuar = false;
      }
      if (continuar && !this.participante.GestorCnpj) {
        if (submeter && this.permitirAvancar) {
          this.camposObrigatorios.erroParticipanteGestorCnpj = true;
          nomeDoCampo = "CNPJ do Gestor";
        }
        this.permitirAvancar = false;
        continuar = false;
      }
      if (continuar) {
        for (let index = 0; index < this.emissoresDeOrdens.length; index++) {
          const obj = this.emissoresDeOrdens[index];
          if (!obj.Nome) {
            this.camposObrigatoriosEmissor[index].erroNome = true;
            this.permitirAvancar = false;
            if (submeter && nomeDoCampo === "")
              nomeDoCampo = "Nome do Emissor de Ordem";
            continuar = false;
            break;
          } else {
            this.camposObrigatoriosEmissor[index].erroNome = false;
          }
          if (!obj.CpfCnpj) {
            this.camposObrigatoriosEmissor[index].erroCpfCnpj = true;
            this.permitirAvancar = false;
            if (submeter && nomeDoCampo === "")
              nomeDoCampo = "CNPJ do Emissor de Ordem";
            continuar = false;
            break;
          } else {
            this.camposObrigatoriosEmissor[index].erroCpfCnpj = false;
          }

          const telefoneValido = this.telefoneValido[`Telefone_${index}`];

          if (!obj.Telefone || telefoneValido == false) {
            if (submeter && this.permitirAvancar) {
              this.camposObrigatoriosEmissor[index].erroTelefone = true;
              nomeDoCampo = "Telefone do Emissor de Ordem";
            }
            if (telefoneValido == false) {
              valorInvalido = true;
            }
            this.permitirAvancar = false;
            continuar = false;
            break;
          } else {
            this.camposObrigatoriosEmissor[index].erroTelefone = false;
          }

          if (this.temErrosEmailPorPrefixo("emailRepresentanteGestor_")) {
            this.permitirAvancar = false;
            if (submeter && nomeDoCampo === "") {
              nomeDoCampo = "e-mail do Emissor de ordem";
            }
            continuar = false;
            break;
          }
        }
      }
      if (continuar && !this.participante.Custodiante) {
        if (submeter && this.permitirAvancar) {
          this.camposObrigatorios.erroParticipanteCustodiante = true;
          nomeDoCampo = "Denominação social ou Nome completo do Custodiante";
        }
        this.permitirAvancar = false;
        continuar = false;
      }
      if (continuar && !this.participante.CustodianteCnpj) {
        if (submeter && this.permitirAvancar) {
          this.camposObrigatorios.erroParticipanteCustodianteCnpj = true;
          nomeDoCampo = "CNPJ do Custodiante";
        }
        this.permitirAvancar = false;
        continuar = false;
      }
      if (submeter && nomeDoCampo != "") {
        if (valorInvalido) {
          this.modalAlerta = {
            mostrar: true,
            tipo: "warning",
            titulo: "Atenção: Campo obrigatório",
            mensagem: `O campo ${nomeDoCampo} foi informado, mas não foi preenchido corretamente. Preencha a informação para avançar.`,
          };
        } else {
          this.modalAlerta = {
            mostrar: true,
            tipo: "warning",
            titulo: "Atenção: Campo obrigatório",
            mensagem: `O campo ${nomeDoCampo} não foi informado ou é inválido, preencha a informação para avançar.`,
          };
        }
      } else if (submeter) {
        if (this.houveAlteracaoRepresentantesCriticos()) {
          var documentoAtivo = await verificarDocumentoAtivo();
          if (documentoAtivo) {
            var confirmado = await confirmarReassinatura();
            if (!confirmado) {
              this.permitirAvancar = false;
              return false;
            }
          }
        }
      }
      return this.permitirAvancar;
    },
    temErrosEmailPorPrefixo(prefixo) {
      return Object.keys(this.emailErros)
        .filter((key) => key.startsWith(prefixo))
        .some((key) => this.emailErros[key] !== "");
    },
    async salvarInformacoes() {
      if (this.houveAlteracaoRepresentantesCriticos()) {
        var documentoAtivo = await verificarDocumentoAtivo();

        if (documentoAtivo) {
          var confirmado = await confirmarReassinatura();
          if (!confirmado) {
            return false;
          }
        }
      }

      this.$store.commit("SET_FI_SALVAR_INFO", true);
      this._repSnap = makeSnapshot(this.representantes);
    },
    salvarAlteracoesLocalmenteParticipante() {
      this.$store.commit("SET_FI_SALVAR_INFO_PARTICIPANTE", this.participante);
      //this.validarFormulario();
    },
    salvarAlteracoesLocalmenteRepresentante() {
      this.$store.commit(
        "SET_FI_SALVAR_INFO_PARTICIPANTE_REPRESENTANTE",
        this.representantes,
      );
      //this.validarFormulario();
    },
    salvarAlteracoesLocalmenteEmissorOrdem() {
      this.$store.commit(
        "SET_FI_SALVAR_INFO_EMISSOR_ORDEM",
        this.emissoresDeOrdens,
      );
      //this.validarFormulario();
    },
    addEmisorOrdem() {
      this.emissor = {
        Guid: "",
        Nome: "",
        CpfCnpj: "",
        Telefone: "",
        Email: "",
        Cargo: "",
        UsPerson: "false",
        PoliticamenteExposta: "false",
      };
      this.emissoresDeOrdens.push({ ...this.emissor });
      if (!this.camposObrigatoriosEmissor) this.camposObrigatoriosEmissor = [];
      this.camposObrigatoriosEmissor.push({
        erroNome: false,
        erroCpfCnpj: false,
        erroEmail: false,
        erroTelefone: false,
      });
    },
    addRepresentanteGestor() {
      this.novoRepresentante = {
        Guid: "",
        Nome: "",
        CpfCnpj: "",
        Tipo: "gestor",
        Telefone: "",
        Email: "",
        Cargo: "",
        Signatario: "false",
        Assinatura: "",
      };
      this.representantes.push({ ...this.novoRepresentante });
      if (!this.camposObrigatoriosRepresentante)
        this.camposObrigatoriosRepresentante = [];
      this.camposObrigatoriosRepresentante.push({
        erroNome: false,
        erroCpfCnpj: false,
        erroAssinatura: false,
      });
    },
    addRepresentanteAdmin() {
      this.novoRepresentante = {
        Guid: "",
        Nome: "",
        CpfCnpj: "",
        Tipo: "representanteAdministrador",
        Telefone: "",
        Email: "",
        Cargo: "",
        Signatario: "false",
        Assinatura: "",
      };
      this.representantes.push({ ...this.novoRepresentante });
      if (!this.camposObrigatoriosRepresentante)
        this.camposObrigatoriosRepresentante = [];
      this.camposObrigatoriosRepresentante.push({
        erroNome: false,
        erroCpfCnpj: false,
        erroAssinatura: false,
      });
    },
    async excluirRepresentante(index) {
      if (this.representantes[index].Assinatura != "1") {
        var documentoAtivo = await verificarDocumentoAtivo();

        if (documentoAtivo) {
          var confirmado = await confirmarReassinatura();
          if (!confirmado) {
            return false;
          }
        }
      }

      if (this.representantes[index].Guid == "") {
        this.representantes.splice(index, 1);
        this.$store.commit(
          "SET_FI_SALVAR_INFO_PARTICIPANTE_REPRESENTANTE",
          this.representantes,
        );
        await this.validarFormulario();
      } else {
        await api
          .get(
            `fundo/representante/excluir?guid=${this.representantes[index].Guid}&tipo=${this.representantes[index].Tipo}`,
          )
          .then((retorno) => {
            if (retorno.status == 200) {
              this.validarFormulario();
              this.$swal({
                icon: "success",
                title: "Exclusão realizada com sucesso!",
                text: "Dados informados foram excluídos com sucesso.",
              });
              this.representantes.splice(index, 1);
              this._repSnap = makeSnapshot(this.representantes);
              this.$store.commit(
                "SET_FI_SALVAR_INFO_PARTICIPANTE_REPRESENTANTE",
                this.representantes,
              );
            }
          })
          .catch((error) => {
            this.$swal({
              icon: "error",
              title: "Dados informados inválidos.",
              text: `${error.response.data.data[0]}`,
            });
          });
      }
    },
    inicializarCamposObrigatoriosRepresentante() {
      this.camposObrigatoriosRepresentante = this.representantes.map(() => ({
        erroNome: false,
        erroCpfCnpj: false,
        erroAssinatura: false,
      }));
    },
    inicializarCamposObrigatoriosEmissor() {
      this.camposObrigatoriosEmissor = this.emissoresDeOrdens.map(() => ({
        erroNome: false,
        erroCpfCnpj: false,
        erroTelefone: false,
        erroEmail: false,
      }));
    },
  },
};
</script>
